// Definición de defaults

export const defaultTipoNotificacion: TipoNotificacionProps = {
    idTipoNotificacion:     0,
    descripcion:            '',
    activo:                 false
};

// Creación de interfaces

export interface TipoNotificacionProps   {
    idTipoNotificacion:     number;
    descripcion:            string;
    activo:                 boolean;
}